import axios from "axios";
import timeZoneOffset from "services/timeZoneOffset";

/**
 * Creates a point component.
 *
 * @param {Object} feature - The feature object.
 * @param {Object} info - The info object.
 * @param {string} objectId - The object ID.
 * @param {string} pointTypeComponentId - The point type component ID.
 * @return {Object} The created point component.
 */
export const createPointComponent = (
  feature,
  info,
  objectId,
  pointTypeComponentId
) => {
  const userId = localStorage.getItem("userId");
  const adminCompanyId = localStorage.getItem("adminCompanyId");
  const { coordinates } = feature.geometry;
  const [lng, lat] = coordinates;

  return {
    attributes: Object.keys(info).map((value) => {
      return {
        name: value,
        value: info[value],
      };
    }),
    locationComponent: {
      longitude: lng,
      latitude: lat,
    },
    pointTypeComponentId,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timeZoneOffset: timeZoneOffset(),
    date: new Date(),
    objectId,
    userId: parseInt(userId),
    adminCompanyId,
  };
};

/**
 * Saves a point component API to the database.
 *
 * @param {Object} pointEvent - The point event to be saved.
 * @return {Object} An object containing the saved data and the response.
 */
const savePointComponentApiPg = async (pointEvent) => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      `${process.env.REACT_APP_URL_BACKEND}api/v1/point-components`,
      pointEvent,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await res.data;
    return { data, res };
  } catch (error) {
    console.error(error);
  }
};

export default savePointComponentApiPg;
